import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of, Subject, BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { APP_CONFIG } from './../../../configs/app-config.constants';
import { InterfaceAppConfig } from '../../../configs/app-interface.config';

@Injectable({
    providedIn: 'root',
})
export class RepoGksService {
    url: any;
    domainUrl = environment.apiurl;
    gyanDomainUrl = environment.gyanApiUrl;

    constructor(
        private http: HttpClient,
        @Inject(APP_CONFIG)
        private config: InterfaceAppConfig,
    ) {}

    getgksList(req: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const url = this.gyanDomainUrl + this.config.apis.admin.listofgks;
        return this.http.post(url, req, { headers: headers });
    }

    createNewGks(req: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const url = this.gyanDomainUrl + this.config.apis.admin.createnewgks;
        return this.http.post(url, req, { headers: headers });
    }

    updateExistingGks(req: any): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const url = this.gyanDomainUrl + this.config.apis.admin.updategks;
        return this.http.post(url, req, { headers: headers });
    }
}
